module.exports = __webpack_public_path__ + "img/analytic_link.0bd7c06c.svg";